import { useSnapshot } from "valtio"
import { filtersState, loginStore } from "../state/CommonState"
import { rtpStore } from "../pricing/pricing-store"
import LCLPricingSchedule from "../pricing/lcl.schedule"
import FCLPricingSchedule from "../pricing/fcl.schedule"
import { getTotalResultCount } from "../mui-components/QuickQuoteFilters"
import RoleUtils from "../util/RoleUtils"
import { PERMISSIONS_NEW } from "../util/constants"
import { useMobile } from "../hooks/usemobile"

const ChargeTable = (props) => {
    if (!props.charge) return <></>
    return <>
        {
            Object.keys(props.charge).map(e => <tr>
                <td></td>
                <td>{e}</td>
                <td>{props.charge[e].category}</td>
                <td colSpan='2'>
                    {
                        props.charge[e].comp ?
                            Object.entries(props.charge[e].comp).map(e1 => '' + e1 + ', ') :
                            'Comp undefined'
                    }
                </td>
                <td>
                    {
                        ((e === "Pick-up Charges" && props.charge[e].total === 0) || (e === "Delivery Charges" && props.charge[e].total === 0)) ?
                            "Charges awaited"
                            : <>
                                Total = {props.charge[e].total} {
                                    typeof props.charge[e].markup != 'undefined' && props.charge[e].markup != 0 ? '(' + props.charge[e].markup + ')' : ''
                                }
                            </>
                    }
                </td>
            </tr>)
        }
    </>
}
export default function SpotFCLDisplayv3(props) {
    useSnapshot(loginStore)
    useSnapshot(rtpStore)
    let routes = props.routes
    let cwfVisible = props.cwfVisible
    let setcwfVisible = props.setcwfVisible
    const isMobile = useMobile();

    if (routes?.length === 0) return <></>

    return (
        <>
            <table className={isMobile ? "is-fullwidth" : "table is-bordered is-fullwidth is-narrow "} style={{ width: '100%', fontSize: '0.75rem', padding: '0px' }}>
                {
                    (!loginStore.isClient() && RoleUtils.isUserAuthorized(PERMISSIONS_NEW.QUICK_QUOTE.RATE_SOURCES) && !isMobile) ?
                        <thead>
                            <tr>
                                <th colSpan={7}>Total Routes =  {routes.length} {props.filteredRoutes?.length ? " / " + getTotalResultCount(props.filteredRoutes) : ""}, Displaying max 100 routes</th>
                            </tr>
                            <tr>
                                <th>ID(Set)</th>
                                <th>POR</th>
                                <th>POL</th>
                                <th>RE</th>
                                <th>POD</th>
                                <th>FPOD</th>
                            </tr>
                        </thead>
                        : <></>
                }
                <tbody>
                    {
                        routes.slice(0, 100).map((route, subscript) => {
                            let e = filtersState.routes.find(({ uid }) => uid === route.refId);
                            subscript = filtersState.routes.findIndex(({ uid }) => uid === route.refId)
                            return <>
                                {
                                    (!loginStore.isClient() && RoleUtils.isUserAuthorized(PERMISSIONS_NEW.QUICK_QUOTE.RATE_SOURCES) && !isMobile) ?
                                        <tr style={{ fontWeight: 'bold' }}>
                                            <td>{e.ID}({e.set})</td>
                                            <td>{e.por}</td>
                                            <td>{e.pol}</td>
                                            <td>{e.rep}</td>
                                            <td>{e.pod}</td>
                                            <td>{e.fpod}</td>
                                        </tr>
                                        : <></>
                                }
                                {
                                    (!loginStore.isClient() && RoleUtils.isUserAuthorized(PERMISSIONS_NEW.QUICK_QUOTE.RATE_SOURCES) && !isMobile) ?
                                        <ChargeTable charge={e.charges} />
                                        : <></>
                                }
                                {
                                    (!loginStore.isClient() && RoleUtils.isUserAuthorized(PERMISSIONS_NEW.QUICK_QUOTE.RATE_SOURCES) && !isMobile) ?
                                        <tr style={{ color: '#a30' }}>
                                            <td colSpan='6'>
                                                Sources :
                                                {
                                                    Object.keys(e.sources).map(k => <p>{JSON.stringify(e.sources[k]).replace(`{"_id":{"ptype":`, `{`)}</p>)
                                                }
                                            </td>
                                        </tr>
                                        : <></>
                                }
                                {
                                    (route.schedule) ?
                                        <tr style={{ color: '#a30' }}>
                                            <td colSpan='6'>
                                                {
                                                    <FCLPricingSchedule
                                                        skipvalidation={true} pricingRec={e} data={route.schedule} contract={e.dummyContract} subscript={subscript} schind={route.schedule} setOpenScheduleModel={props.setOpenScheduleModel} setOpenChargeModel={props.setOpenChargeModel} createbooking={props.createbooking}
                                                        hideme={setcwfVisible} cwfVisible={cwfVisible} setOpenCopyMail={props.setOpenCopyMail} getquote={props.getquote} />
                                                }
                                            </td>
                                        </tr>
                                        : <></>
                                }
                                {
                                    (!route.schedule) ?
                                        <tr style={{ color: '#a30' }}>
                                            <td colSpan='6'>
                                                <FCLPricingSchedule pricingRec={e} contract={e.dummyContract} isDummy={true} schind={0} subscript={subscript} setOpenScheduleModel={props.setOpenScheduleModel} setOpenChargeModel={props.setOpenChargeModel} createbooking={props.createbooking}
                                                    hideme={setcwfVisible} cwfVisible={cwfVisible} setOpenCopyMail={props.setOpenCopyMail} getquote={props.getquote} />
                                            </td>
                                        </tr>
                                        : <></>
                                }
                            </>
                        })
                    }
                </tbody>
            </table>
        </>
    )
}